import React from "react";
import { useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import SortIcon from "@material-ui/icons/Sort";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  container: {
    maxHeight: 440
  }
});

const TableFinalized = props => {
  const classes = useStyles();
  const {
    data,
    totalCount,
    page,
    rowsPerPage,
    onChangePage,
    onChangeRowsPerPage,
    orderBy,
    orderType,
    onOrderChange,
    columnFilters,
    onColumnFilterChange,
    moduleType,
    months_open,
    days_open,
    actualGroup
  } = props;

  const handleChangePage = (event, newPage) => {
    onChangePage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    onChangeRowsPerPage(+event.target.value);
  };

  const sortIconStyle = field => ({
    transform: `rotate(${orderBy === field && orderType === "asc" ? "180" : "0"}deg)`,
    transition: "all 0.2s"
  });

  const dictTypeRequest = useSelector(state => state.currentList.DICCIONARIO_TIPO_SOLICITUD_PEDIDO);

  return (
    <Paper className={classes.root}>
      <TextField
        label="Buscar por Id o Paciente"
        value={columnFilters.q || ""}
        onChange={e => onColumnFilterChange("q", e.target.value)}
        style={{ margin: "16px" }}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ minWidth: "50px" }}>
                Id
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => onOrderChange("id")}
                >
                  <SortIcon style={sortIconStyle("id")} />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "70px" }}>
                Tipo de pedido
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={columnFilters.tipo_solicitud || ""}
                  onChange={e =>
                    onColumnFilterChange("tipo_solicitud", e.target.value.substr(0, 20))
                  }
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value={"Programado"}>Programado</MenuItem>
                  <MenuItem value={"urgente"}>Urgente</MenuItem>
                  <MenuItem value={"HabilitacionDomicilio"}>
                    Habilitación de domicilio
                  </MenuItem>
                  <MenuItem value={"EquipoUrgente"}>Equipo urgente</MenuItem>
                  <MenuItem value={"EquipoHabilitacion"}>
                    Equipo habilitación
                  </MenuItem>
                </Select>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Fecha de solitud
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => onOrderChange("fecha_solicitud")}
                >
                  <SortIcon style={sortIconStyle("fecha_solicitud")} />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Estado picking
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={columnFilters.estado_picking || ""}
                  onChange={e =>
                    onColumnFilterChange("estado_picking", e.target.value.substr(0, 20))
                  }
                  label="Age"
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value={"incompleta"}>Incompleta</MenuItem>
                  <MenuItem value={"completa"}>Completa</MenuItem>
                </Select>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Fecha a despachar
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => onOrderChange("fecha_despacho")}
                >
                  <SortIcon style={sortIconStyle("fecha_despacho")} />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Paciente
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => onOrderChange("nombre_paciente")}
                >
                  <SortIcon style={sortIconStyle("nombre_paciente")} />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "60px" }}>
                Región
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={columnFilters.es_region || ""}
                  onChange={e =>
                    onColumnFilterChange("es_region", e.target.value.substr(0, 20))
                  }
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value={"si"}>Si</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Días de atraso
              </TableCell>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Estado pedido
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => onOrderChange("estado_solicitud")}
                >
                  <SortIcon style={sortIconStyle("estado_solicitud")} />
                </IconButton>
              </TableCell>
              <TableCell align="center">Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
                <TableRow key={row.id} align="center">
                  <TableCell align="center">{row.id}</TableCell>
                  <TableCell align="center">{dictTypeRequest[row.tipo_solicitud]?.label || row.tipo_solicitud}</TableCell>
                  <TableCell align="center">{row.fecha_solicitud}</TableCell>
                  <TableCell align="center">{row.estado_picking}</TableCell>
                  <TableCell align="center">{row.fecha_despacho}</TableCell>
                  <TableCell align="center">{row.nombre_paciente}</TableCell>
                  <TableCell align="center">
                    {row.es_region ? "Si" : "No"}
                  </TableCell>
                  <TableCell align="center">
                    Meses: {months_open(row.fecha_tentativa_llegada)}
                     /  Días:
                    {days_open(row.fecha_tentativa_llegada)}
                  </TableCell>
                  <TableCell align="center">
                    {row[`estado_solicitud_${actualGroup}`]
                      ? row[`estado_solicitud_${actualGroup}`]
                      : row.estado_solicitud}
                  </TableCell>
                  <TableCell align="center">
                    <Link to={`/admin/warehouse/order/${moduleType}/${row.id}`}>
                      <Button
                        style={{ textTransform: "none" }}
                        variant="contained"
                        color="primary"
                      >
                        Detalle
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "Filas por página" },
          native: false
        }}
        labelRowsPerPage={"Filas por página"}
        nextIconButtonText={"Siguiente"}
        backIconButtonText={"Atrás"}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to === -1 ? count : to} de ${
            count !== -1 ? count : `más que ${to}`
          }`
        }
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TableFinalized;

TableFinalized.propTypes = {
  data: PropTypes.array,
  totalCount: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  orderBy: PropTypes.string,
  orderType: PropTypes.string,
  onOrderChange: PropTypes.func,
  columnFilters: PropTypes.object,
  onColumnFilterChange: PropTypes.func,
  moduleType: PropTypes.string,
  months_open: PropTypes.func,
  days_open: PropTypes.func,
  actualGroup: PropTypes.string
};
